import { createAction } from '@reduxjs/toolkit';

import {
  ICreateOrganizationUser,
  IError,
  IOrderOrganizationDevicesRequest,
  IOrganization,
  IOrganizationDevice,
  IOrganizationDevices,
  IOrganizationUser,
  IOrganizationUsers,
  IRegisterOrganizationDevicesRequest,
} from '../../interfaces';
import { IOrganizationDevicesSort, IOrganizationUsersRoleFilter, IOrganizationUsersSort } from './types';

export const resetOrganization = createAction('organization.reset-organization');
export const resetRemoveOrganizationDeviceStatus = createAction('organization.reset-remove-organization-device-status');
export const resetRegisterOrganizationDevicesStatus = createAction(
  'organization.reset-register-organization-devices-status',
);
export const resetOrderOrganizationDevicesStatus = createAction('organization.reset-order-organization-devices-status');
export const resetCreateOrganizationUserStatus = createAction('organization.reset-create-organization-user-status');
export const resetChangeOrganizationUserRoleStatus = createAction(
  'organization.reset-change-organization-user-role-status',
);
export const resetDeleteOrganizationUserStatus = createAction('organization.reset-delete-organization-user-status');

export const updateOrganizationDevicesSearchText = createAction<{ searchText: string }>(
  'organization.update-organization-devices-search-text',
);
export const updateOrganizationDevicesSort = createAction<{ sort: IOrganizationDevicesSort }>(
  'organization.update-organization-devices-sort',
);
export const updateOrganizationUsersSearchText = createAction<{ searchText: string }>(
  'organization.update-organization-users-search-text',
);
export const updateOrganizationUsersRoleFilter = createAction<{ filters: IOrganizationUsersRoleFilter }>(
  'organization.update-organization-users-role-filter',
);
export const updateOrganizationUsersSort = createAction<{ sort: IOrganizationUsersSort }>(
  'organization.update-organization-users-sort',
);

export const fetchOrganization = createAction('organization.fetch-organization');
export const fetchOrganizationSucceeded = createAction<{ organization: IOrganization }>(
  'organization.fetch-organization.succeeded',
);
export const fetchOrganizationFailed = createAction<IError>('organization.fetch-organization.failed');

export const fetchOrganizationDevices = createAction('organization.fetch-organization-devices');
export const fetchOrganizationDevicesSucceeded = createAction<{ devices: IOrganizationDevices }>(
  'organization.fetch-organization-devices.succeeded',
);
export const fetchOrganizationDevicesFailed = createAction<IError>('organization.fetch-organization-devices.failed');

export const removeOrganizationDevice = createAction<{ device: IOrganizationDevice }>(
  'organization.remove-organization-device',
);
export const removeOrganizationDeviceSucceeded = createAction<{ devices: IOrganizationDevices }>(
  'organization.remove-organization-device.succeeded',
);
export const removeOrganizationDeviceFailed = createAction<IError>('organization.remove-organization-device.failed');

export const registerOrganizationDevices = createAction<{ request: IRegisterOrganizationDevicesRequest }>(
  'organization.register-organization-devices',
);
export const registerOrganizationDevicesSucceeded = createAction(
  'organization.register-organization-devices.succeeded',
);
export const registerOrganizationDevicesFailed = createAction<IError>(
  'organization.register-organization-devices.failed',
);

export const orderOrganizationDevices = createAction<{ request: IOrderOrganizationDevicesRequest }>(
  'organization.order-organization-devices',
);
export const orderOrganizationDevicesSucceeded = createAction('organization.order-organization-devices.succeeded');
export const orderOrganizationDevicesFailed = createAction<IError>('organization.order-organization-devices.failed');

export const fetchOrganizationUsers = createAction('organization.fetch-organization-users');
export const fetchOrganizationUsersSucceeded = createAction<{ users: IOrganizationUsers }>(
  'organization.fetch-organization-users.succeeded',
);
export const fetchOrganizationUsersFailed = createAction<IError>('organization.fetch-organization-users.failed');

export const createOrganizationUser = createAction<{ user: ICreateOrganizationUser }>(
  'organization.create-organization-user',
);
export const createOrganizationUserSucceeded = createAction<{ users: IOrganizationUsers }>(
  'organization.create-organization-user.succeeded',
);
export const createOrganizationUserFailed = createAction<IError>('organization.create-organization-user.failed');

export const changeOrganizationUserRole = createAction<{ user: IOrganizationUser }>(
  'organization.change-organization-user-role',
);
export const changeOrganizationUserRoleSucceeded = createAction<{ users: IOrganizationUsers }>(
  'organization.change-organization-user-role.succeeded',
);
export const changeOrganizationUserRoleFailed = createAction<IError>(
  'organization.change-organization-user-role.failed',
);

export const deleteOrganizationUser = createAction<{ user: IOrganizationUser }>(
  'organization.delete-organization-user',
);
export const deleteOrganizationUserSucceeded = createAction<{ users: IOrganizationUsers }>(
  'organization.delete-organization-user.succeeded',
);
export const deleteOrganizationUserFailed = createAction<IError>('organization.delete-organization-user.failed');
